import React, { createContext, useContext, useState } from 'react';
import { SellInvoice } from '../types/sale';
import * as api from '../api/saleApi';

interface SaleContextProps {
    sales: SellInvoice[];
    sale: SellInvoice | undefined;
    fetchSales: () => Promise<void>;
    fetchSale: (id: string) => Promise<void>;
    addSale: (sale: Partial<SellInvoice>) => Promise<SellInvoice>;
    updateSale: (sale: SellInvoice) => Promise<void>;
    deleteSale: (id: string) => Promise<void>;
}

const SaleContext = createContext<SaleContextProps>({} as any);

export const SaleProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [sales, setSales] = useState<SellInvoice[]>([]);
    const [sale, setSale] = useState<SellInvoice>();

    const fetchSales = async () => setSales(await api.fetchSales());

    const fetchSale = async (id: string) => setSale(await api.fetchSale(id));

    const addSale = async (sale: Partial<SellInvoice>) => {
        const newSale = await api.addSale(sale);
        setSales(s => [newSale, ...s]);
        return newSale;
    };
    const updateSale = async (sale: SellInvoice) => {
        const updated = await api.updateSale(sale.id!, sale);
        setSales(s => s.map(x => x.id === sale.id ? updated : x));
        setSale(updated);
    };
    const deleteSale = async (id: string) => {
        await api.deleteSale(id);
        setSales(s => s.filter(x => x.id !== id));
    };

    return (
        <SaleContext.Provider value={{ sales, sale, fetchSales, addSale, updateSale, deleteSale, fetchSale }}>
            {children}
        </SaleContext.Provider>
    );
};

export const useSale = () => useContext(SaleContext);
